import Http from '@/ship/Http';
import { GetRequestParams } from '@/ship/Requests/RequestParams';

export const getWeekends = (params?: GetRequestParams) => {
    return Http.get('/calendar', { params });
};
